import script from "./assetsCard.vue?vue&type=script&setup=true&lang=js"
export * from "./assetsCard.vue?vue&type=script&setup=true&lang=js"

import "./assetsCard.vue?vue&type=style&index=0&id=29fd8c42&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29fd8c42"]])

export default __exports__